import { render, staticRenderFns } from "./productDescription.vue?vue&type=template&id=bb094bf2&scoped=true&"
import script from "./productDescription.vue?vue&type=script&lang=js&"
export * from "./productDescription.vue?vue&type=script&lang=js&"
import style0 from "./productDescription.vue?vue&type=style&index=0&id=bb094bf2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb094bf2",
  null
  
)

export default component.exports